import React from 'react';
import './buttonLike.css'


class CustomButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bg_color:'white',
            hightLight : 'false'
        }
    }

    handleClick = (e)=> {
        if (this.props.type.indexOf('file') !== -1) {
            this.props.showFileSearch(e);
        } else if (this.props.type.indexOf('article') !== -1) {
            this.props.showArticle(e);
        }

    };

    render() {
        return(
            <div onClick={this.handleClick} className= {this.props.type}>

            </div>
        );
    }
}

export default CustomButton;